<template>
  <div>
    <AppModal
      v-if="modalToggle"
      :message="message"
      :btnCase="btnCase"
      @modalConfirm="modalConfirm"
    />
    <div class="app-header flex-x-center flex-space-between">
      <div class="icoBack" @click.stop.prevent='backBtn' v-if="previousOrder"/>
      <img src="@/assets/img/bi_order_app_v.png" class="app-header-bi">
    </div>
    <div class="keypad-group">
      <p>간편로그인</p>
      <KeyPad
        ref="pwd"
        class="keypad-input"
        :padSwitch="padSwitch"
        @firstPwd="firstPwd"
      />
      <div class="loginInfo"></div>
      <p v-show="confirmFaild" class="keypad-fail" v-html="showResultMsg"></p>
    </div>
    <div class="loginMain" :class="{top350: confirmFaild}">
      <p @click="findPwd">비밀번호 찾기</p>
    </div>
    <components
      v-if="currentComponent != null"
      :is="currentComponent"
      :visible="visible"
      :shareData="shareData"
      :authType="authType"
      @nextComponent="nextComponent"
      @closeComponentEmit="closeComponentToggle"
      class="pop-top"
    />
  </div>
</template>

<script>
import service from '@/backend/modnpay_app_api'
import KeyPad from '@/components/Common/KeyPad.vue'
import AppSignUpAgreePage from '@/views/AppSignUpAgreePage.vue'
import AppSignUpAuthPage from '@/views/AppSignUpAuthPage.vue'
import AppSignUpPwdPage from '@/views/AppSignUpPwdPage.vue'
import AppSignUpFinPage from '@/views/AppSignUpFinPage.vue'
/* eslint-disable eqeqeq */
export default {
  components: {
    KeyPad,
    AppSignUpAgreePage,
    AppSignUpAuthPage,
    AppSignUpPwdPage,
    AppSignUpFinPage
  },
  data () {
    return {
      padSwitch: true, // true pwd1 false pwd2
      visible: true, // 간편회원가입 ui show/hide
      // currentComponent: AppSignUpPwdPage,
      currentComponent: null,
      shareData: {},
      showResultMsg: '', // 실패 메세지
      confirmFaild: false, // 실패 메세지 보여줄지 말지
      authType: 0, // 0: 비밀번호 찾기 1: 회원가입 2 재설치 본인인증, 3: 성인인증
      /** 모달 */
      modalToggle: false,
      message: '본인인증이 필요합니다',
      btnCase: 1,
      previousPageName: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previousPageName = from.name
    })
  },
  computed: {
    previousOrder () {
      return this.previousPageName == 'ORDER'
    }
  },
  watch: {
    currentComponent () {
      if (this.currentComponent == null) {
        this.confirmFaild = false
      } else {
        this.$refs.pwd.passwd = ''
      }
    }
  },
  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
  },
  methods: {
    backBtn () {
      history.back()
    },
    appMoveCheck () {
      if (localStorage.getItem('joinFlag')) {
        this.$router.push({ name: 'AppOrderSelect' })
      } else {
        this.appMoveMain()
      }
    },
    // 회원가입
    signUp () {
      this.visible = true
      this.authType = 1
      this.currentComponent = AppSignUpAgreePage
    },
    // 비밀번호 찾기
    findPwd () {
      this.visible = false
      this.authType = 0
      this.currentComponent = AppSignUpAuthPage
    },
    // 재설치 본인인증
    modalConfirm () {
      this.modalToggle = false
      this.visible = false
      this.authType = 2
      this.currentComponent = AppSignUpAuthPage
    },
    // is 컴포넌트 이동
    nextComponent (value) {
      this.currentComponent = value.componentName
      this.shareData = value.componentData
    },
    // is 컴포넌트 닫기
    closeComponentToggle () {
      this.currentComponent = null
      this.shareData = {}
    },
    // 로그인
    async firstPwd (value) {
      const req = {
        deviceId: localStorage.getItem('deviceId'),
        passwd: value
      }
      const { data } = await service.appLogin(req)
      const code = data.resultCode

      if (code == 0) {
        localStorage.setItem('Authorization', data.accessToken)
        this.appMoveFirstAddress()
      } else if (code == 30018) {
        this.modalToggle = true
        this.$refs.pwd.passwd = ''
        this.confirmFaild = false
      } else if (code == 30098) {
        this.$router.push({
          name: 'AppLoginOverlap',
          query: {}
        })
      } else {
        this.$refs.pwd.passwd = ''
        this.confirmFaild = true
        this.showResultMsg = data.resultMsg
      }
    }
  }
}
</script>

<style scoped>
</style>
